<template>
  <div>
    <div class="fxd .f -z-n">
      <img style="object-fit: cover;" class="abs .f " src="~@/assets/bg.png">
    </div>
    <HeaderPart></HeaderPart>
    <Container>
      <div class="rlt">
      <div class="a-c">
        <!--div> Coronavirus covid 19 </div>
        <p class="o-5">{{ $t('home_description') }}</p-->
        <iframe data-aa="1405879" src="//acceptable.a-ads.com/1405879" scrolling="no" style="border:0px; padding:0; width:100%; height:100%; overflow:hidden" allowtransparency="true"></iframe>
      </div>
      <section class="g@">
        <div class="x12 l:x6 l:p-5 l:m-b-6 b h-vh l:h-a">
          <div class="l20 d1 -o-h -r-m h-i b b-cl e-1 w-f" >
            <SummaryWidget></SummaryWidget>
            <ListWidget class="h-15 -o-a b-fg" style="margin-top: -170px;padding-top: 170px;min-height: 600px;-webkit-mask-image: linear-gradient(transparent, rgb(0, 0, 0) 40%);"></ListWidget>
          </div>
        </div>
        <div class="x12 l:x6 l:p-b-6">
        <div id="info-panel" class="l:p-5 fxd l:stt .f > -o-y-a" :class="countryPanelOpen && $route.query.country?'':'slide-on-mobile'">
          <div class="l:-d-n abs .f c20"></div>
          <div  class="l:-d-n h-10 b b-a-c b-j-sb rlt e-4 -z-1">
            <div class="b b-c">
              <div class="unt btn-n u-8 m-x-4 c0-t">
                <i class="material-icons">bar_chart</i>
              </div>{{ $t('data_of') }}  <span v-if="country" class="m-s-3"> {{ country.name }} </span>
            </div>
            <div class="b">
              <div class="unt btn-n u-8 m-x-4" @click="countryPanelOpen=false">
                <i class="material-icons">close</i>
              </div>
            </div>
          </div>
          <DetailsWidget style="--el-u:0; --el-p:0;" class="l20 d1 -o-h -r-m rlt e-1 l:m-b-6"></DetailsWidget>
          <!--iframe data-aa="1405127" src="//ad.a-ads.com/1405127?size=728x90" scrolling="no" style="width:100%; height:90px; border:0px; padding:0; overflow:hidden" allowtransparency="true"></iframe-->
          <ChartWidget class="l20 d1 -o-h -r-m p-5 rlt e-1 l:m-b-6" ></ChartWidget>
          <PostsWidget class="e-1 l20 d1 -o-h -r-m" ></PostsWidget>
        </div>
      </div>
      </section>
      </div>
    </Container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// Widgets
import SummaryWidget from '../widgets/Summary'
import ListWidget from '../widgets/List'
import DetailsWidget from '../widgets/Details'
import ChartWidget from '../widgets/Chart'
import PostsWidget from '../widgets/Posts'
// Parts
import HeaderPart from '../parts/header'
// Components
import Container from '../components/physia/Container'
// import SwingTitle from '../components/SwingTitle'

export default {
  name: 'Home',
  components: {
    SummaryWidget,
    ListWidget,
    DetailsWidget,
    ChartWidget,
    PostsWidget,
    Container,
    HeaderPart
    // SwingTitle
  },
  computed: {
    ...mapState(['countries', 'countriesData', 'selectedCountry']),
    ...mapGetters(['getSelectedCountries', 'isMedia', 'convertToNumberWithSuffix'])
  },
  data () {
    return {
      loadingPosts: true,
      orderArabCountriesBy: 'cases',
      countryCard: null,
      country: 0,
      countryPanelOpen: 0,
      chartData: {
        labels: [],
        datasets: []
      },
      chartOptions: {
        title: {
          display: true,
          text: 'DATA CENTER'
        }
      },
      chartStyles: {
        height: '300px',
        width: '100%',
        position: 'relative'
      }
    }
  },
  watch: {
    selectedCountry (newValue, oldValue) {
      this.countryPanelOpen = 1
    },
    countryPanelOpen (newValue, oldValue) {
      if (newValue && (this.$store.getters.isMedia('s') || this.$store.getters.isMedia('m'))) {
        document.scrollingElement.classList.add('-o-h', 'scrolling-element')
      } else {
        if (document.querySelector('.scrolling-element')) {
          document.querySelector('.scrolling-element').classList.remove('-o-h', 'scrolling-element')
        }
      }
    }
  },
  mounted () {
    (window.adsbygoogle = window.adsbygoogle || []).push({})
  }
}
</script>
